import { render, staticRenderFns } from "./Owners.vue?vue&type=template&id=b1c3446c&scoped=true&"
import script from "./Owners.vue?vue&type=script&lang=ts&"
export * from "./Owners.vue?vue&type=script&lang=ts&"
import style0 from "./owners.scss?vue&type=style&index=0&id=b1c3446c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1c3446c",
  null
  
)

export default component.exports